export default function Returns() {
  return (
    <div className="bg-[#FFF4E0] min-h-screen" data-testid="returns-page">
      <section className="max-w-3xl mx-auto px-6 py-20 md:py-28">
        <div className="overline mb-3">House Notes</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A0F11]">Returns & Refunds</h1>
        <div className="prose prose-lg mt-10 text-[#1A0F11] space-y-6 font-body">
          <p className="text-[#5C4A4D] leading-relaxed">We stand fiercely behind every crown that leaves the house. If your order isn&apos;t everything you hoped for, here&apos;s how we&apos;ll make it right.</p>

          <div>
            <h2 className="font-serif-display text-2xl text-[#1A0F11] mb-2">14-Day Window</h2>
            <p className="text-[#5C4A4D] leading-relaxed">Unopened, unaltered items in their original sealed packaging can be returned within 14 days of delivery for a full refund (excluding original shipping).</p>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-[#1A0F11] mb-2">Non-Returnable</h2>
            <ul className="list-disc pl-6 text-[#5C4A4D] space-y-1">
              <li>Wigs, bundles, frontals or closures whose packaging has been opened, tape removed or hair washed/cut/coloured.</li>
              <li>Hair care products that have been opened or used.</li>
              <li>Earrings, bonnets and any intimate accessories.</li>
              <li>Sale and promotional items.</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-[#1A0F11] mb-2">How to Return</h2>
            <ol className="list-decimal pl-6 text-[#5C4A4D] space-y-1">
              <li>Email <a href="mailto:returns@thehairbutik.com" className="text-[#831132] hover:underline">returns@thehairbutik.com</a> within 14 days of delivery with your order number.</li>
              <li>We&apos;ll issue a returns authorisation and address within 24 hours.</li>
              <li>Ship the item back tracked. Return shipping is the customer&apos;s responsibility.</li>
              <li>Refunds are issued to the original payment method within 5 business days of receipt.</li>
            </ol>
          </div>

          <div>
            <h2 className="font-serif-display text-2xl text-[#1A0F11] mb-2">Faulty or Wrong Items</h2>
            <p className="text-[#5C4A4D] leading-relaxed">In the rare event your order arrives faulty or incorrect, contact us within 48 hours and we&apos;ll cover the return shipping and send a replacement immediately.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
